import { FileUploadTypeEnum, VideoAssetTypeEnum, VideoAssetResponse } from '$Generated/api';
import * as MediaUrlBuilder from '$Components/Shared/MediaUrlBuilder';

const FrontVideo = 'FrontVideo';
const RearVideo = 'RearVideo';
const Thumbnail = 'Thumbnail';
const Transcode = 'Transcode';

function findAssets(
    assets: VideoAssetResponse[],
    fileUploadType: FileUploadTypeEnum,
    specificTypes?: VideoAssetTypeEnum[],
    channelNumber?: number,
): VideoAssetResponse | undefined {
    const foundAssets = assets.filter((asset) => {
        if (typeof asset.fileUploadTypeId === 'undefined') return false;
        if (fileUploadType !== asset.fileUploadTypeId) return false;

        if (channelNumber != null && asset.channelNumber != null && asset.channelNumber !== channelNumber) return false;
        return true;
    });
    let result;

    if (specificTypes && foundAssets) {
        specificTypes.find((type) =>
            foundAssets.find((asset) => {
                if (asset.type === type) {
                    result = asset;
                    return true;
                }
            }),
        );
    }

    return result;
}

function findUrl(
    assets: VideoAssetResponse[],
    baseUrl: string,
    fileUploadType: FileUploadTypeEnum,
    type?: VideoAssetTypeEnum[],
    channelNumber?: number,
): string {
    const asset = findAssets(assets, fileUploadType, type, channelNumber);
    const url = MediaUrlBuilder.buildUrl(asset, baseUrl);

    return url;
}

export const findPreviewUrls: (assets: VideoAssetResponse[] | [], baseUrl: string) => VideoPreviewUrls = (
    assets: VideoAssetResponse[],
    baseUrl: string,
) => {
    // Find thumbnail in assets if not exist we go we front or rear video
    const defaultThumbnail = assets.find((asset) => asset.type === Thumbnail);
    const channelNumber = defaultThumbnail?.channelNumber;
    const previewFileUploadTypes = [defaultThumbnail?.fileUploadTypeId || FrontVideo, RearVideo];
    const previewAssetTypes = [Transcode] as VideoAssetTypeEnum[];

    const uploadType = previewFileUploadTypes.find((type) =>
        findAssets(assets, type as FileUploadTypeEnum, previewAssetTypes, channelNumber),
    ) as FileUploadTypeEnum;

    const previewUrl = findUrl(assets, baseUrl, uploadType, previewAssetTypes, channelNumber);
    const thumbanilUrl =
        findUrl(assets, baseUrl, uploadType, [Thumbnail], channelNumber) || MediaUrlBuilder.buildUrl(defaultThumbnail, baseUrl);
    const downloadUrl = findUrl(assets, baseUrl, uploadType, [Transcode], channelNumber);

    return {
        ThumbnailUrl: thumbanilUrl,
        PreviewUrl: previewUrl,
        DownloadUrl: downloadUrl,
    };
};

export interface VideoPreviewUrls {
    ThumbnailUrl: string;
    PreviewUrl: string;
    DownloadUrl: string;
}
